
import XButton from 'vux/src/components/x-button/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'

import { getNotice } from '@/service/vioReport'
import {mapGetters} from 'vuex'
export default {
components: {
XButton
},
data () {
return {
text: '',
show1: false,
content: {}
}
},
computed: {
...mapGetters(['isElder'])
},
created () {
this.getNotice()
},
mounted () {
setTimeout(() => {
this.content.forEach((el) => {
console.log(document.getElementById(el.title), el.title, 'pppp')
document
.getElementById(el.title)
.addEventListener('click', function () {
AlertModule.show({
title: '提示',
content: el.content,
onShow () {
console.log("Plugin: I'm showing")
},
onHide () {
console.log("Plugin: I'm hiding")
}
})
})
})
}, 500)
},
methods: {
click () {
this.$router.push({ name: 'reportMain', path: '/reportMain' })
},
getNotice () {
this.$vux.loading.show({
text: '加载中'
})
getNotice('report.user.notice')
.then((response) => {
this.$vux.loading.hide()
const result = response.data
this.text = result.data.csz
this.content = JSON.parse(result.data.sm)
})
.catch((err) => {
this.$vux.loading.hide()
this.$vux.toast.show({
text: '获取失败，' + err,
type: 'warn'
})
})
}
}
}



// WEBPACK FOOTER //
// ./src/views/vioReport/ReportNotice.vue